module.exports = __webpack_public_path__ + "media/7-qi.a73f0296.mp3";